import {
    Home,
    DollarSign,
    Droplet,
    Percent,
    List,
    Truck,
    Users,
    Bookmark,
    Bell,
    Share,
    Star,
} from 'react-feather';

export const MENUITEMSADMIN = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        icon: Home,
        type: 'link',
        badgeType: 'primary',
        active: false,
    },
    {
        title: 'Pedidos',
        icon: Droplet,
        type: 'link',
        active: false,
        path: '/recargas',
    },
    {
        title: 'Pagos recibidos',
        icon: DollarSign,
        type: 'link',
        active: false,
        path: '/pago-movil',
    },
    {
        title: 'Precios',
        icon: List,
        type: 'link',
        active: false,
        path: '/precios',
    },
    {
        title: 'Clientes',
        icon: Users,
        path: '/clientes',
        type: 'link',
        active: false,
    },
    {
        title: 'Calificaciones',
        icon: Star,
        type: 'link',
        active: false,
        path: '/calificaciones',
    },
    {
        title: 'Novedades',
        icon: Bell,
        path: '/novedades',
        type: 'link',
        active: false,
    },
    {
        title: 'Formas de pago',
        path: '/formas_de_pago',
        type: 'link',
        icon: DollarSign,
        active: false,
    },
    {
        title: 'Formas de entrega',
        path: '/formas_de_entrega',
        type: 'link',
        icon: Truck,
        active: false,
    },
    {
        title: 'Usuarios',
        path: '/usuarios',
        type: 'link',
        icon: Users,
        active: false,
    },
    {
        title: 'Franquicias',
        icon: Bookmark,
        path: '/franquicias',
        type: 'link',
        active: false,
    },
    {
        title: 'Cupones',
        icon: Percent,
        path: '/cupones',
        type: 'link',
        active: false,
    },
    {
        title: 'Invitar cliente',
        icon: Share,
        type: 'link',
        active: false,
        path: '/invitar-cliente',
    },
];

export const MENUITEMSFRANCHISE = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        icon: Home,
        type: 'link',
        badgeType: 'primary',
        active: false,
    },
    {
        title: 'Recargas',
        icon: Droplet,
        type: 'link',
        active: false,
        path: '/recargas',
    },
    {
        title: 'Pagos recibidos',
        icon: DollarSign,
        type: 'link',
        active: false,
        path: '/pago-movil',
    },
    {
        title: 'Precios',
        icon: List,
        type: 'link',
        active: false,
        path: '/precios',
    },
    {
        title: 'Clientes',
        icon: Users,
        path: '/clientes',
        type: 'link',
        active: false,
    },
    {
        title: 'Calificaciones',
        icon: Star,
        type: 'link',
        active: false,
        path: '/calificaciones-usuario',
    },
    {
        title: 'Invitar cliente',
        icon: Share,
        type: 'link',
        active: false,
        path: '/invitar-cliente',
    }
];

export const MENUITEMSDELIVERY = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        icon: Home,
        type: 'link',
        badgeType: 'primary',
        active: false,
    },
    {
        title: 'Recargas',
        icon: Droplet,
        type: 'link',
        active: false,
        path: '/recargas',
    },
    {
        title: 'Precios',
        icon: List,
        type: 'link',
        active: false,
        path: '/precios',
    },
    {
        title: 'Nuevo cliente',
        icon: Users,
        type: 'link',
        active: false,
        path: '/nuevo-cliente',
    },
    {
        title: 'Calificaciones',
        icon: Star,
        type: 'link',
        active: false,
        path: '/calificaciones-usuario',
    },
    {
        title: 'Invitar cliente',
        icon: Share,
        type: 'link',
        active: false,
        path: '/invitar-cliente',
    },
];
